import React, { useState, useEffect } from 'react';
import { Sidebar, Header, CustomSelect, LoadingPage } from '../common';
import { CustomDatePicker, InputBox } from './common/';
import { WaterTable } from './tables';
import { getAllUser, getAllBuilding, getUtilities, getSnapshot, getSnapshotDate, saveSnapshot, saveUtilities, getArisuData } from "./ApiService";
import WarningLoginModal from '../buildingPages/modals/WarningLoginModal';

import InformationCircleIcon from "./assets/information-circle.svg";
import ExclamationCircleIcon from "./assets/exclamation-circle.svg";
import FindIcon from "./assets/find-icon.svg"
import Uploading from "./assets/uploading.svg"
import UploadComplete from "./assets/upload-complete.svg"

import '../styles/billingPageStyles.css';
import '../styles/styles.css';
import './Water.css';

const convertString2Int = (string) => {
    return parseInt(String(string).replace(/,/g, ''), 10) || 0
}
const convertInt2String = (num) => {
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const convertRound = (value) => {
    return Math.round(value);
};
const priceUnitCutting = (value) => {
    return Math.floor(value / 10) * 10;
};
const safeValue = (value) => {
    if (isNaN(value) || value === Infinity || value === -Infinity) {
        return 0;
    }
    return value;
}

const Water = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 7);
    const [date, setDate] = useState(formattedDate);
    const [allowedMonths, setAllowedMonths] = useState([formattedDate]);

    const [isUploading, setIsuploading] = useState(false);
    const [isLoadingArisu, setIsLoadingArisu] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);

    const role = sessionStorage.getItem("role");
    const [users, setUsers] = useState(sessionStorage.getItem("userName"));
    const [userId, setUserId] = useState("");

    const [arisuDate, setArisuDate] = useState(formattedDate);
    const [arisuNumber, setArisuNumber] = useState("");
    const [arisuUserName, setArisuUserName] = useState("");
    const [arisuButtonDisable, setArisuButtonDisable] = useState(false);

    const buildingData = JSON.parse(sessionStorage.getItem("building")) || [];
    const [buildings, setBuildings] = useState(buildingData.reduce((acc, item) => {
        acc[item.id] = item.buildingName;
        return acc;
    }, {}));
    const [buildingId, setBuildingId] = useState(sessionStorage.getItem("lastBuilding") || Object.keys(buildings)[0] ||  null);
    const hasBuilding = buildingId !== null;
    
    const [beforeSaveTableData, setBeforeSaveTableData] = useState({
        date: formattedDate,
        buildingUtilitiesInfo: {
            buildingWaterPrice: 0,
            buildingPrevWaterUsed: 0,
            buildingCurrWaterUsed: 0,
        },
        roomUtilitiesInfoList: [],
        roomTotalWaterUsed: 0,
        roomCommonUsed: 0,
        totalRoomCommonUsedPrice: 0
    });
    const [tableData, setTableData] = useState({
        date: formattedDate,
        buildingUtilitiesInfo: {
            buildingWaterPrice: 0,
            buildingPrevWaterUsed: 0,
            buildingCurrWaterUsed: 0,
        },
        roomUtilitiesInfoList: [],
        roomTotalWaterUsed: 0,
        roomCommonUsed: 0,
        totalRoomCommonUsedPrice: 0
    });    

    const generateTableData = (waterData) => {
        const buildingUtilitiesInfo = waterData.buildingUtilitiesInfo;
        const roomUtilitiesInfoList = waterData.roomUtilitiesInfoList;

        const buildingWaterUsed = buildingUtilitiesInfo.buildingCurrWaterUsed - buildingUtilitiesInfo.buildingPrevWaterUsed;

        const totalRoomPrivateArea = roomUtilitiesInfoList
            .filter(room => room.roomStatus === "CONTRACT")
            .reduce((sum, room) => sum + room.roomPrivateArea, 0);
        
        const roomTotalWaterUsed = roomUtilitiesInfoList
            .filter(room => room.roomStatus === "CONTRACT")
            .reduce((sum, room) => sum + (room.roomCurrWaterUsed - room.roomPrevWaterUsed), 0);

        const unitWaterPrice = safeValue(buildingUtilitiesInfo.buildingWaterPrice / buildingWaterUsed);
        const roomCommonUsed = buildingWaterUsed - roomTotalWaterUsed
        const totalRoomCommonUsedPrice = convertRound(roomCommonUsed * unitWaterPrice)
        
        const processedRoomInfoList = roomUtilitiesInfoList.map(room => {
            if (room.roomStatus === "CONTRACT") {
                const privateAreaRatio = safeValue(room.roomPrivateArea / totalRoomPrivateArea);
                
                const roomWaterUsed = room.roomCurrWaterUsed - room.roomPrevWaterUsed;
                const roomWaterPrice = convertRound(roomWaterUsed * unitWaterPrice)
                const roomCommonWaterPrice = convertRound(totalRoomCommonUsedPrice * privateAreaRatio);

                return {
                    ...room,
                    privateAreaRatio,
                    roomWaterUsed,
                    roomWaterPrice,
                    roomCommonWaterPrice,
                    totalWaterAndCommonWaterPrice: roomWaterPrice + roomCommonWaterPrice,
                    totalPrice: priceUnitCutting(roomWaterPrice + roomCommonWaterPrice + room.roomWaterChangePrice),
                }
            } else {
                return {
                    ...room,
                    privateAreaRatio: 0,
                    roomWaterUsed: 0,
                    roomWaterPrice: 0,
                    roomCommonWaterPrice: 0,
                    totalWaterAndCommonWaterPrice: 0,
                    totalPrice: 0,
                }
            }
        });

        return {
            date: date,
            buildingUtilitiesInfo,
            roomUtilitiesInfoList: processedRoomInfoList,
            roomTotalWaterUsed,
            roomCommonUsed,
            totalRoomCommonUsedPrice
        }
    }
    const handleValueChange = (field, newValue) => {
        setTableData(prevData => ({
            ...prevData,
            buildingUtilitiesInfo: {
                ...prevData.buildingUtilitiesInfo,
                [field]: newValue
            }
        }))
    };
    const updateRoomUtilitiesInfoList = (roomId, field, newValue) => {
        setTableData(prevData => ({
            ...prevData,
            roomUtilitiesInfoList: prevData.roomUtilitiesInfoList.map(room =>
                room.roomId === roomId ? {
                    ...room,
                    [field]: newValue
                } : room
            )
        }))
    };

    const handleLoadArisuInfo = () => {
        if (role !== "USER" && role !== "ADMIN") {
            setIsWarningModalOpen(true);
            return;
        }
        if (arisuUserName === "" || arisuNumber === "") {
            alert("고객번호와 수용가명을 입력해주세요.");
            return;
        }
        const updateArisuData = (data) => {
            if (data.buildingWaterPrice === null) {
                alert("아리수 요금조회에 실패했습니다.");
                return;
            }
            setTableData((prevTableData) => ({
                ...prevTableData,
                buildingUtilitiesInfo: {
                    ...prevTableData.buildingUtilitiesInfo,
                    buildingPrevWaterUsed: data.buildingPrevWaterUsed,
                    buildingCurrWaterUsed: data.buildingCurrWaterUsed,
                    buildingWaterPrice: data.buildingWaterPrice
                }
            }))
        }
        setArisuButtonDisable(true)
        getArisuData(arisuDate, arisuUserName, arisuNumber, setIsLoadingArisu, updateArisuData, setArisuButtonDisable);
    }

    useEffect(() => {
        if (role === "ADMIN") {
            getAllUser(setUsers)
        }
    }, [])

    useEffect(() => {
        if (role === "ADMIN") {
            getAllBuilding(userId, buildings, setBuildings, setBuildingId);
        }
    }, [userId, buildings])

    // tableData 변경시 snapshot과 변경데이터 서버에 전송
    useEffect(() => {
        const generatedData = generateTableData(tableData)

        if (JSON.stringify(generatedData) !== JSON.stringify(beforeSaveTableData)) {
            setBeforeSaveTableData(generatedData)
            setTableData(generatedData);

            setIsuploading(true);

            const handleSaveUtilities = async () => {
                await saveUtilities(date, buildingId, generatedData);
            };
            const handleSaveSnapshot = async () => {
                await saveSnapshot(date, buildingId, generatedData, "water");
            };
            
            if (date === formattedDate) {
                Promise.all([handleSaveUtilities(), handleSaveSnapshot()])
                    .then(() => {
                        setIsuploading(false);
                    })
                    .catch(error => {
                        // console.log("저장중 에러발생: ", error);
                        setIsuploading(false);
                    });
            } else {
                handleSaveSnapshot()
                    .then(() => {
                        setIsuploading(false);
                    })
                    .catch(error => {
                        // console.log("저장중 에러발생: ", error);
                        setIsuploading(false);
                    });
            };
        }
    }, [tableData])

    // buildingId와 date로 서버에서 데이터 불러오기
    useEffect(() => {
        if (date === formattedDate) {
            getUtilities(buildingId, date, setIsLoading, setTableData, generateTableData); 
        } else {
            getSnapshot("water", buildingId, date, setIsLoading, setTableData);
        }
    }, [buildingId, date]);

    useEffect(() => {
        getSnapshotDate(buildingId, setAllowedMonths); 
    }, [buildingId]);

    if (isLoading) {
        return <LoadingPage />;
    }
    return(
        <div className="page">
            <Sidebar />
            <div className="sideBarElseContainer">
                <Header pageName="수도세 계산기"/>
                <div className="headerElseContainer">
                    <div className="billingPageContainer">
                        <div className="billingPageLeftContainer">
                            {role === "ADMIN" ? (
                                <CustomSelect placeholder="사용자를 선택해주세요" customSelectList={users} parentCustomSelect={userId} setParentCustomSelect={setUserId} />
                            ) : (<></>)}
                            <CustomSelect placeholder="건물을 선택해주세요" customSelectList={buildings} parentCustomSelect={buildingId} setParentCustomSelect={setBuildingId} />
                            <div className="saving-status-container">
                                {isLoadingArisu ? (
                                    <div className="uploading-status-container">
                                        <img src={Uploading} alt="uploading" className='uploading' />
                                        <span className="uploadingSpan">
                                            불러오기...
                                        </span>
                                    </div>
                                ) : (
                                    isUploading ? (
                                        <div className="uploading-status-container">
                                            <img src={Uploading} alt="uploading" className='uploading' />
                                            <span className="uploadingSpan">
                                                저장중...
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="upload-complete-status-container">
                                            <img src={UploadComplete} alt="upload-complete" className="uploadComplete"/>
                                            <span className="uploadCompleteSpan">
                                                저장완료!
                                            </span>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                        <CustomDatePicker placeholder="년월을 선택해주세요" allowedMonths={allowedMonths} date={date} setDate={setDate} />
                    </div>
                    <div className='billingTopContainer'>
                        <div className='waterMeterContainer'>
                            <div className="billingTopInfo">
                                <img src={InformationCircleIcon} alt="Information" className='informationCircle' />
                                아래 항목을 입력하여 호실별 청구금액을 계산할 수 있어요
                            </div>
                            <div className="arisuLoadContainer">

                                <div className="arisuInputdDate">
                                    <div className='arisuText'>납기년월</div>
                                    <CustomDatePicker placeholder="년월을 선택해주세요" allowedMonths={[]} date={arisuDate} setDate={setArisuDate} />
                                </div>
                                <div className="arisuInputArisuNumber">
                                    <div className='arisuText'>고객번호</div>
                                    <input className='arisuInputBox' placeholder="고객번호 입력" type='text' value={arisuNumber} onChange={(e) => setArisuNumber(e.target.value)}/>
                                </div>
                                <div className="arisuInputUserName">
                                    <div className='arisuText'>수용가명</div>
                                    <input className='arisuInputBox' placeholder="수용가명 입력"type='text' value={arisuUserName} onChange={(e) => setArisuUserName(e.target.value)}/>
                                </div>
                                <button className={`waterBillButton ${arisuButtonDisable ? 'arisuDisabled' : ''}`} onClick={handleLoadArisuInfo} disabled={arisuButtonDisable}>
                                {arisuButtonDisable ? (
                                        <>
                                            <img src={FindIcon} className='findIcon' alt="loading" />
                                            불러오는 중...
                                        </>
                                    ) : (
                                        <>
                                            <img src={FindIcon} className='findIcon' alt="find-icon" />
                                            아리수 요금조회
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                        <div className='waterBillInputContainer'>
                            <InputBox prefix="누적 전월사용량" placeholder="0" postfix="" value={convertInt2String(tableData["buildingUtilitiesInfo"].buildingPrevWaterUsed || 0)} setValue={(newValue) => handleValueChange("buildingPrevWaterUsed", newValue)} error={(tableData["buildingUtilitiesInfo"].buildingPrevWaterUsed || 0) > (tableData["buildingUtilitiesInfo"].buildingCurrWaterUsed || 0)}/>
                            <InputBox prefix="누적 현월사용량" placeholder="0" postfix="" value={convertInt2String(tableData["buildingUtilitiesInfo"].buildingCurrWaterUsed || 0)}setValue={(newValue) => handleValueChange("buildingCurrWaterUsed", newValue)} error={(tableData["buildingUtilitiesInfo"].buildingPrevWaterUsed || 0) > (tableData["buildingUtilitiesInfo"].buildingCurrWaterUsed || 0)}/>
                            <InputBox prefix="수도세 청구금액" placeholder="0" postfix="원" value={convertInt2String(tableData["buildingUtilitiesInfo"].buildingWaterPrice || 0)} setValue={(newValue) => handleValueChange("buildingWaterPrice", newValue)} />
                        </div>
                        <div className='waterBillAutoInputContainer'>
                            <InputBox prefix="전체 수도사용량" placeholder="0" postfix="" value={convertInt2String(tableData.roomCommonUsed + tableData.roomTotalWaterUsed) || 0} disabled={true} />
                            <InputBox prefix="호실 수도사용량" placeholder="0" postfix="" value={convertInt2String(tableData.roomTotalWaterUsed) || 0} disabled={true} error={(tableData.roomTotalWaterUsed || 0) > ((tableData.roomCommonUsed || 0) + (tableData.roomTotalWaterUsed || 0))} />
                            <InputBox prefix="공용 수도청구금액" placeholder="0" postfix="원" value={convertInt2String(tableData.totalRoomCommonUsedPrice) || 0} disabled={true} />
                        </div>
                    </div>
                    <div className='billingBtmContainer'>
                        <div className='billingBtmInfo'>
                            {(role !== "USER" && role !== "ADMIN") ? (
                                <div className="billingBtmInfoExplain">
                                    <img src={ExclamationCircleIcon} alt="Information" className='exclamationCircle' />
                                    로그인하시면 계산 내용을 저장할 수 있습니다.
                                </div>
                            ) : (<></>)}
                        </div>
                        <div className="billingRoomCalculator">
                            <WaterTable hasBuilding={hasBuilding} roomInfo={tableData.roomUtilitiesInfoList} setRoomInfo={updateRoomUtilitiesInfoList} />
                        </div>
                    </div>
                    <WarningLoginModal
                        isOpen={isWarningModalOpen}
                        message="아리수 요금조회를 사용하려면 로그인이 필요해요"
                        onClose={() => setIsWarningModalOpen(false)}
                    />
                </div>
            </div>
        </div>
    );
};

export default Water;